import store from '@store/index'
import {AdminRoleRepo} from '@services/repos/adminRoleRepo';

const adminRoleRepo = new AdminRoleRepo()


export const adminService = {
    syncPermissions() {
        return new Promise((resolve, reject) => {
            adminRoleRepo.getAwailablePermissions()
                .then(res => {
                    const permissions = new Set(res.data)
                    store.commit('main/setPermissions', permissions)
                    resolve(permissions)
                })
                .catch(reject)
        })
    },
    hasPermission(val) {
        const permissions = store.getters['main/permissions']
        return permissions.has(val)
    },
    hasPermissions(val = []) {
        if (val.length === 0) return true
        return !val.map((x) => this.hasPermission(x)).includes(false)
    },
    getPermissions() {
        return store.getters['main/permissions']
    }
}
